import { defineComponent } from "vue";
import StepOffers from "../../steps/b2c/StepOffers";
import StepCalc from "../../steps/b2c/StepCalc";
import StepCalcForm from "../../steps/b2c/StepCalcForm";
import StepForm from "../../steps/b2c/StepForm";
import Utils from "../../utils/Utils";
import StepOfferDetails from "../../steps/b2c/StepOfferDetails";
import { OfferJson } from "../../OrderForm";

export default defineComponent({
    components: {
        StepOffers,
        StepOfferDetails,
        StepCalc,
        StepCalcForm,
        StepForm,
    },

    template: `
        <StepCalc
            v-if="isStep('noinvoice')"

            @next="setStep('noinvoice.offers')"
        />

        <StepOffers
            v-if="isStep('noinvoice.offers')"
            :options="options"

            @offer:select="setStep('noinvoice.details')"
        />

        <StepOfferDetails
            v-if="isStep('noinvoice.details')"
            :offer="options.offer"
            :code="options.code"

            @offer:select="setStep('noinvoice.calcform', $event)"
        />

        <StepCalcForm
            v-if="isStep('noinvoice.calcform')"
            :options="options"

            @back="setStep('offers.all')"
            @next="setStep('noinvoice.form.invoice', options.offer)"
        />

        <StepForm
            v-if="isStep('noinvoice.form*')"
            :options="options"
            step_prefix="noinvoice.form."

            :visible_upload="true"

            @back="setStep('offers.all')"
        />
    `,

    props: {
        options: { type: Object, required: true },
    },

    methods: {
        isStep(val: string) {
            return Utils.isStep(val);
        },

        setStep(step: string, offer?: OfferJson) {
            Utils.setStep(step, offer);
        },
    },
});
